import '../styles/PageGlobal.css';
import './TVANewPage.css';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReferenceButton from '../components/ReferenceButton';
import TVACountryPicker from '../components/TVACountryPicker';
import { TVAService } from '../services/TVAService.js';

export default function TVANewPage() {
  const navigate = useNavigate();
  const [showCountryPicker, setShowCountryPicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const [form, setForm] = useState({ 
    produitReference: '', 
    codeDouane: '', 
    ddomRate: '', 
    daRate: '', 
    tvaRate: '', 
    tvaState: null 
  });

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSave = async () => {
    const service = new TVAService();
    setLoading(true);
    try {
      const payload = {
        produitReference: form.produitReference,
        codeDouane: form.codeDouane,
        ddomRate: form.ddomRate === '' ? null : parseFloat(form.ddomRate),
        daRate: form.daRate === '' ? null : parseFloat(form.daRate),
        tvaRate: form.tvaRate === '' ? null : parseFloat(form.tvaRate),
        tvaState: form.tvaState
      };
      await service.createTVA(payload);
      alert("TVA créée avec succès !");
      navigate("/tva_list");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="containerMain tva-new-container">
      <h1 className="tva-new-title">Créer une TVA</h1>
      <p className="tva-new-subtitle">Ceci est un contenu protégé</p>
      {error && <div className="tva-error">{error}</div>}

      {showCountryPicker && (
        <TVACountryPicker 
          onClose={() => setShowCountryPicker(false)} 
          onSelect={(stateObj) => { 
            setForm(prev => ({...prev, tvaState: stateObj})); 
            setShowCountryPicker(false); 
          }} 
        />
      )}

      <div className="tva-new-actions">
        <ReferenceButton onClick={() => setShowCountryPicker(true)}>
          + Sélectionner un État/Pays ({form.tvaState?.label || 'Aucun'})
        </ReferenceButton>
      </div>

      <div className="tva-new-form">
        <div className="tva-new-row">
          <label>Référence Produit</label>
          <input type="text" name="produitReference" value={form.produitReference} onChange={handleChange} />
        </div>
        <div className="tva-new-row">
          <label>Code Douane</label>
          <input type="text" name="codeDouane" value={form.codeDouane} onChange={handleChange} />
        </div>
        <div className="tva-new-row">
          <label>OM (%)</label>
          <input type="number" step="0.01" name="ddomRate" value={form.ddomRate} onChange={handleChange} />
        </div>
        <div className="tva-new-row">
          <label>DA (%)</label>
          <input type="number" step="0.01" name="daRate" value={form.daRate} onChange={handleChange} />
        </div>
        <div className="tva-new-row">
          <label>TVA (%)</label>
          <input type="number" step="0.01" name="tvaRate" value={form.tvaRate} onChange={handleChange} />
        </div>
      </div>

      <div className="tva-new-footer">
        <button className="tva-btn tva-btn-blue" onClick={handleSave} disabled={loading}>{loading ? '...' : 'Enregistrer'}</button>
        <button className="tva-btn tva-btn-grey" onClick={() => navigate("/tva_list")} disabled={loading}>Annuler</button>
      </div>
    </div>
  );
}